import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {Column as CustomColumn, InnerRow, DateAndTime} from '~/shared/components/UserTransactions/components/styled';

const ColumnWithBorder = styled(CustomColumn)`
  border-bottom: 2px solid ${({theme}) => theme.colors.darkBackground};

  &:last-child {
    border-bottom: 0;
  }
`;

const LoaderColumnWithBorder = styled(ColumnWithBorder)`
  ${flipOnLTR`
    padding-left: 12px;
  `}
`;

const SkeletonMobileInnerRow = styled(InnerRow)`
  margin-bottom: 10px;
`;

const MobileLoaderComponent = () => {
  return (
    <>
      <LoaderColumnWithBorder key={1} narrow noPaddingLeft>
        <SkeletonMobileInnerRow>
          <div>
            <Skeleton width={42} height={10} />
          </div>
          <div>
            <Skeleton width={61} height={10} />
          </div>
        </SkeletonMobileInnerRow>
        <SkeletonMobileInnerRow>
          <DateAndTime>
            <Skeleton width={61} height={10} />
          </DateAndTime>
          <div>
            <Skeleton width={42} height={10} />
          </div>
        </SkeletonMobileInnerRow>
      </LoaderColumnWithBorder>

      <LoaderColumnWithBorder key={2} narrow noPaddingLeft>
        <SkeletonMobileInnerRow>
          <div>
            <Skeleton width={42} height={10} />
          </div>
          <div>
            <Skeleton width={61} height={10} />
          </div>
        </SkeletonMobileInnerRow>
        <SkeletonMobileInnerRow>
          <DateAndTime>
            <Skeleton width={61} height={10} />
          </DateAndTime>
          <div>
            <Skeleton width={42} height={10} />
          </div>
        </SkeletonMobileInnerRow>
      </LoaderColumnWithBorder>

      <LoaderColumnWithBorder key={3} narrow noPaddingLeft>
        <SkeletonMobileInnerRow>
          <div>
            <Skeleton width={42} height={10} />
          </div>
          <div>
            <Skeleton width={61} height={10} />
          </div>
        </SkeletonMobileInnerRow>
        <SkeletonMobileInnerRow>
          <DateAndTime>
            <Skeleton width={61} height={10} />
          </DateAndTime>
          <div>
            <Skeleton width={42} height={10} />
          </div>
        </SkeletonMobileInnerRow>
      </LoaderColumnWithBorder>
    </>
  );
};

export default MobileLoaderComponent;
